import React from 'react';

const GoogleAuthIcon = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none"
  },
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_25758_222174)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.12988 1.12988C9.18135 0.426345 11.4124 0.446169 13.4512 1.18555V1.18652C14.4083 1.54251 15.2963 2.05823 16.0801 2.70898C16.0458 2.74307 16.0116 2.77793 15.9766 2.8125L15.4912 3.29883C14.996 3.79574 14.4986 4.29034 14.002 4.78516C13.4218 4.3168 12.7576 3.96089 12.042 3.74121L12.0391 3.74023C10.9297 3.4066 9.74981 3.38507 8.62891 3.67773C7.50943 3.97008 6.49167 4.5647 5.6875 5.39648C4.98735 6.10875 4.45654 6.97018 4.13574 7.91602C3.67665 9.26799 3.67672 10.7339 4.13574 12.0859V12.0869C4.55821 13.3286 5.33825 14.4158 6.375 15.2129L6.58594 15.3682C7.29944 15.8761 8.11103 16.2298 8.96875 16.4072L8.97852 16.4092C9.81871 16.5654 10.6813 16.5654 11.5215 16.4092L11.5205 16.4082C12.3638 16.2644 13.1682 15.9476 13.8818 15.4756L13.8857 15.4727C14.4594 15.0858 14.9497 14.5873 15.3262 14.0068C15.7025 13.4265 15.9579 12.7761 16.0771 12.0947L16.1797 11.5078H10.6982V8.65039H19.0732C19.2948 10.1902 19.1906 11.761 18.7656 13.2607C18.3461 14.7406 17.532 16.0786 16.4102 17.1309C15.3304 18.1119 14.0143 18.7954 12.5908 19.1152L12.5859 19.1172C10.9998 19.4901 9.34629 19.4716 7.76855 19.0645H7.76758C5.83048 18.543 4.11146 17.4145 2.8623 15.8447C1.61196 14.2734 0.898109 12.3427 0.826172 10.3359C0.7543 8.32915 1.32822 6.35207 2.46289 4.69531C3.59763 3.03858 5.23371 1.78906 7.13086 1.13086L7.12988 1.12988Z",
      fill: "white",
      stroke: "white"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6.96758 0.657073C9.1283 -0.0847125 11.4779 -0.0643102 13.6254 0.714886C14.8048 1.15639 15.8854 1.82651 16.8051 2.68676C16.4926 3.02114 16.1629 3.33364 15.8441 3.65864C15.2379 4.26384 14.6322 4.86697 14.027 5.46801C13.4236 4.89104 12.6938 4.463 11.8957 4.21801C10.8744 3.90964 9.78792 3.88852 8.75542 4.15698C7.72292 4.42544 6.78432 4.97311 6.04258 5.73989C5.39513 6.39854 4.90481 7.19491 4.6082 8.06957L1.36914 5.56176C2.52853 3.26264 4.53594 1.50399 6.96758 0.657073Z",
      fill: "#E33629"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M0.509175 8.04688C0.683271 7.18405 0.972306 6.34848 1.36855 5.5625L4.60761 8.07656C4.18389 9.32438 4.18389 10.6772 4.60761 11.925C3.52845 12.7583 2.44876 13.5958 1.36855 14.4375C0.376598 12.463 0.07407 10.2133 0.509175 8.04688Z",
      fill: "#F8BD00"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.198 8.14844H19.498C19.8161 9.89365 19.73 11.6885 19.2464 13.3953C18.8015 14.9648 17.9371 16.3834 16.7464 17.4984C15.7011 16.6828 14.6511 15.8734 13.6058 15.0578C14.124 14.7082 14.5663 14.2576 14.9063 13.733C15.2462 13.2084 15.4766 12.6205 15.5839 12.0047H10.198C10.1964 10.7203 10.198 9.43437 10.198 8.14844Z",
      fill: "#587DBD"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M1.36719 14.4383C2.4474 13.6049 3.52708 12.7674 4.60625 11.9258C5.02376 13.1511 5.81782 14.2131 6.875 14.9602C7.53439 15.4262 8.28364 15.7497 9.075 15.9102C9.85478 16.0551 10.6546 16.0551 11.4344 15.9102C12.2119 15.7785 12.9533 15.4858 13.6109 15.0508C14.6562 15.8664 15.7063 16.6758 16.7516 17.4914C15.6076 18.5316 14.2132 19.2568 12.7047 19.5961C11.0397 19.9875 9.30457 19.9687 7.64844 19.5414C6.3386 19.1917 5.11512 18.5751 4.05469 17.7305C2.93228 16.8394 2.01556 15.7164 1.36719 14.4383Z",
      fill: "#319F43"
    }
  )),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_25758_222174" }, /* @__PURE__ */ React.createElement("rect", { width: "20", height: "20", fill: "white" })))
);

export { GoogleAuthIcon };
//# sourceMappingURL=GoogleAuthIcon.js.map
